import { useEvaluationContext, useFeatureFlag } from '@platform/feature-flags';
import { updateSentrySamplingRates } from '@platform/observability';
import { useEffect } from 'react';

export function ObservabilitySamplingSync() {
  const [context] = useEvaluationContext();
  const errors = useFeatureFlag('sentry-error-sampling', true);
  const traces = useFeatureFlag('sentry-traces-sampling', true);
  const replaysSession = useFeatureFlag('sentry-replays-session-sampling');
  const replaysOnError = useFeatureFlag('sentry-replays-on-error-sampling');

  useEffect(() => {
    if (!context.userId) {
      return;
    }

    updateSentrySamplingRates({
      errors: errors ? 1 : 0,
      traces: traces ? 1 : 0,
      replaysSession: replaysSession ? 1 : 0,
      replaysOnError: replaysOnError ? 1 : 0,
    });
  }, [context.userId, errors, traces, replaysSession, replaysOnError]);

  return null;
}
